import { cn } from "@/lib/utils";

interface DividerProps {
  className?: string;
  orientation?: "horizontal" | "vertical";
  opacity?: number;
}

export function Divider({
  className,
  orientation = "horizontal",
  opacity = 20,
}: DividerProps) {
  const baseClasses =
    orientation === "horizontal" ? "w-full h-px" : "h-full w-px";

  const opacityClass = `bg-white/${opacity}`;

  return (
    <div
      className={cn(baseClasses, opacityClass, className)}
      role="presentation"
      aria-hidden="true"
    />
  );
}
